module.exports = __webpack_public_path__ + "static/media/beatiful_forest_and_water.01f145d1.mp3";